import { makeStyles } from "@material-ui/core/styles";

const teamScoreStyles = makeStyles(() => ({
	score: {
		width: 120,
		height: 56
	}
}));

export default teamScoreStyles;
